<template>
  <div class="inventoryInformation">
    <a-table
      class="inventoryTable"
      id="inventoryTable"
      bordered
      :pagination="false"
      :columns="table.columns"
      :rowKey="record => record.id"
      :dataSource="table.data"
      :loading="table.loading"
      @change="handleTableChange">
    </a-table>
  </div>
</template>

<script>
import { getInventoryInformation } from '@/api/sparePartsManagement'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) this.initTableData()
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      table: {
        data: [],
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => {
              return index + 1
            },
            align: 'center',
            width: 40
          },
          {
            title: '所在库存',
            dataIndex: 'location'
          },
          {
            title: '库存数量',
            dataIndex: 'count'
          }
        ],
        loading: false
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 23,
        showSizeChanger: true,
        showQuickJumper: true
      },
    }
  },
  methods: {
    initTableData () {
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      console.log('params inventoryInformation_' + this.model.id, params)
      getInventoryInformation(params).then(res => {
        if (res.status === 0) {
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        }
      })
    },
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.initTableData()
    },
  }
}
</script>

<style lang="less" scoped>
.inventoryInformation{
  margin-left: -1px;
  margin-right: -1px;
  margin-bottom: -1px;
  // margin-bottom: 10px;
  /deep/.ant-table{
    .ant-table-thead{
      > tr{
        > th{
          background: rgba(8,64,159,0.1);
        }
      }
    }
    .ant-table-row-expand-icon {
      margin-right: 0;
    }
  }
  /deep/.ant-table-bordered{
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td{
      border-color: #DDDDDD;
    }
    .ant-table-header > table,
    .ant-table-body > table,
    .ant-table-fixed-left table,
    .ant-table-fixed-right table{
      border-color: #DDDDDD;
    }
  }
}
</style>